<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="clickTab">
      <el-tab-pane label="待随访">
        <followUpList v-if="update0" followupType="待随访" />
      </el-tab-pane>
      <el-tab-pane label="已随访">
        <followUpList v-if="update1" followupType="已随访" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import followUpList from './followUpWaiting.vue';

export default {
  components: { followUpList },
  data() {
    return {
      update0: true,
      update1: false,
    };
  },
  methods: {
    clickTab(tab) {
      this.update0 = tab.label === "待随访";
      this.update1 = tab.label === "已随访";
    }
  }
};
</script>

<style></style>
